import { Components } from "@mui/material/styles/components";
import { FountainBlue } from "@themes:palette";

export default {
  MuiToggleButtonGroup: {
    defaultProps: {
      size: "small",
      color: "primary",
    },
    styleOverrides: {
      root: {
        "&.MuiToggleButtonGroup-root": {
          "& button": {
            minWidth: 100,
          },
          "& button:first-of-type": {
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
          },
          "& button:last-child": {
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
          },
        },
        "& button.Mui-selected": {
          fontWeight: "bold",
          border: `1px solid ${FountainBlue[500]} !important`,
        },
      },
    },
  } as Components["MuiToggleButton"],
};
